module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fb-Gc-Hc-Ia.ab75c94f.png";